export const ACCOUNT_PAGES_URL = '/my_account/loan';
